import { CreateActivityLogRequest } from "features/Core/HomePage/state/activity-logs-interface";
import { CreateTaskRequest } from "features/Core/HomePage/state/tasks-interface";
import { ListModel } from "shared/interfaces/core-interfaces";

export interface Attachment {
    id: string,
    fileName: string,
    description: string,
    fileBase64: string,
    createdAt: Date,
    filePrefix: string
}

export interface CommunicationListResponse {
    id: string,
    logId: string, // connected activity log (always present)
    taskId?: string | null, // connected task (null when the communication list has no task)
    status?: ListModel<number>,
    createdAt: Date,
    createdBy: ListModel<string>,
    category: ListModel<number>,
    isIncoming: boolean,
    documentType: ListModel<number>,
    ourResponsiblePerson?: ListModel<string>,
    ourCompany: ListModel<string>,
    clientResponsiblePerson: ListModel<string>,
    clientCompany: ListModel<string>,
    source: ListModel<string>,
    mobilePhone?: string,
    telephone?: string,
    email?: string,
    reason?: string,
    result?: string,
    files: Attachment[];
}

export interface CreateCommunicationListRequest {
    activityLog: CreateActivityLogRequest,
    task?: CreateTaskRequest
}

export interface CreateCommunicationListResponse {
    id: string,
    message: string,
    communicationList: CommunicationListResponse[];
}

export interface UpdateCommunicationListResponse {
    id: string,
    message: string,
}

export interface UpdateCommunicationListRequest {
    communicationListId: string;
    taskStatusId?: number;
    activityLogTypeId?: number;
    isIncoming: boolean;
    taskResponsiblePerson?: string;
    activityLogOutcome?: number;
}

export interface CommunicationListSliceModel {
    statusCode: string,
    isLoading: boolean,
    message: string,
    showNotification: boolean
}

export const initialTimeTravelSliceValue: CommunicationListSliceModel = {
    statusCode: "",
    isLoading: false,
    message: "",
    showNotification: false
}